import { Control, FieldValues, FormProps } from 'react-hook-form'

import { FormControl, FormField, FormItem, FormMessage } from '@/components/atoms/ui/form'
import { Label } from '@/components/atoms/ui/label'

import { Textarea as FormTextArea } from './ui/textarea'

interface Input extends FormProps<FieldValues> {
  name: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control?: Control<any, unknown>
  placeholder?: string
  label?: string
  required?: boolean
  className?: string
  type?: string
  hint?: string
}

export const Textarea: React.FC<Input> = ({
  control,
  name,
  placeholder,
  label,
  required = false,
  className,
  hint,
  ...props
}) => {
  return (
    <FormField
      {...props}
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className={className}>
          {label && (
            <Label className="text-black">
              {label} {required && <span className="text-red-600">*</span>}
            </Label>
          )}
          <FormControl>
            <FormTextArea placeholder={placeholder} {...field} />
          </FormControl>
          {hint && <span className="text-xs text-red-600">{hint}</span>}
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
